// utils/scoreUtils.js
export const getScoreColor = (score, max = 100) => {
  const safeMax = Number(max) || 0;
  const percentage = safeMax > 0
    ? (safeMax === 100 ? Number(score) || 0 : ((Number(score) || 0) / safeMax) * 100)
    : 0;

  if (percentage >= 100) return 'success';
  if (percentage >= 70) return 'info';
  if (percentage >= 50) return 'warning';
  return 'error';
};

export const getScoreColorHex = (score, max = 100) => {
  const safeMax = Number(max) || 0;
  const percentage = safeMax > 0
    ? (safeMax === 100 ? Number(score) || 0 : ((Number(score) || 0) / safeMax) * 100)
    : 0;

  if (percentage >= 100) return '#16a34a';
  if (percentage >= 70) return '#2563eb';
  if (percentage >= 50) return '#f59e0b';
  return '#dc2626';
};
